module.exports = __webpack_public_path__ + "static/media/IconSearch.2e443483.svg";